/* global axios */

import ApiClient from './ApiClient';

function buildFormData(cannedObj) {
  const formData = new FormData();
  Object.keys(cannedObj).forEach(key => {
    if (key === 'attachments') {
      cannedObj.attachments.forEach(file => {
        formData.append('canned_response[attachments][]', file);
      });
    } else {
      formData.append(`canned_response[${key}]`, cannedObj[key]);
    }
  });
  return formData;
}

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  create(cannedObj) {
    const formData = buildFormData(cannedObj);
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(id, cannedObj) {
    const formData = buildFormData(cannedObj);
    return axios.patch(`${this.url}/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new CannedResponse();
